import { Ditto } from '@ow/ditto-core'
import * as DtDropSelect from '../fields/dropselect'

export const ditto = new Ditto()

ditto.registeWidget('dropSelect', {
  render: DtDropSelect.Statistics,
})

export default ditto
